import { useMutation, useQueryClient } from '@tanstack/react-query';
import { editPcmpProposalSection } from '../api/pcmpProposals.api';
import type {
  PcmpProposalEditPayloads,
  PcmpProposalEditSection,
} from '../types/pcmpProposal.types';
import { pcmpProposalEditCallbacks } from '../utils/pcmpProposalEditCallbacks';

export function useEditPcmpProposalSection<S extends PcmpProposalEditSection>(
  proposalId: number,
  section: S,
  onSuccess: () => void,
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: PcmpProposalEditPayloads[S]) =>
      editPcmpProposalSection(proposalId, section, payload),
    ...pcmpProposalEditCallbacks(queryClient, proposalId, 'Proposal updated', onSuccess),
  });
}
